export default "__VITE_ASSET__08f30325__"